/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SubscriptionMobilityStatusEnum = 'RECEIVED' | 'FAILED' | 'PROCESSED' | 'VALIDATED';

export const SubscriptionMobilityStatusEnum = {

    RECEIVED: 'RECEIVED' as SubscriptionMobilityStatusEnum,

    FAILED: 'FAILED' as SubscriptionMobilityStatusEnum,

    PROCESSED: 'PROCESSED' as SubscriptionMobilityStatusEnum,

    VALIDATED: 'VALIDATED' as SubscriptionMobilityStatusEnum
};

